<div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 mb-4">
    <div
        class="shadow-md rounded-md p-4"
        [ngClass]="{
        'bg-gray-50/75': !darkMode,
        'bg-gray-800': darkMode,
        'text-white': darkMode,
        'text-black': !darkMode,
        'border-gray-200': !darkMode,
        'border-gray-700': darkMode,
        'hover:bg-gray-700': darkMode,
        'hover:bg-gray-100': !darkMode,
    }"></div>
</div>
